import {
    CategoryScale,
    Chart,
    ChartData,
    ChartOptions,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Line } from "react-chartjs-2";
import { connect, ConnectedProps } from "react-redux";

import { StoreState } from "store";
import { resolveColor } from "utils/commonFunctions";

const connector = connect((state: StoreState) => ({
    theme: state.themeReducer.theme,
}));

interface ChartProps {
    chartData: ChartData<"line">;
    displayLegend?: boolean;
    horizontalStacking?: boolean;
    verticalStacking?: boolean;
}

type Props = ChartProps & ConnectedProps<typeof connector>;

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ChartDataLabels);

const LineChartWidget = ({ displayLegend = false, ...props }: Props): JSX.Element => {
    const getChartOptions = (gridLineColor: string, textColor: string): ChartOptions<"line"> => {
        return {
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    beginAtZero: true,
                    ticks: {
                        color: textColor,
                    },
                },
                y: {
                    display: true,
                    grid: {
                        color: gridLineColor,
                    },
                    ticks: {
                        color: textColor,
                        maxTicksLimit: 6,
                    },
                    stacked: props.verticalStacking,
                },
            },
            elements: {
                line: {
                    tension: 0,
                },
                point: {
                    radius: 2,
                },
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                tooltip: {
                    enabled: true,
                },
                legend: {
                    display: displayLegend,
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        color: textColor,
                    },
                },
                datalabels: {
                    display: false,
                },
            },
        };
    };

    return (
        <Line
            data={props.chartData}
            options={getChartOptions(resolveColor("--app-chart-gridLineColor"), resolveColor("--app-chart-textColor"))}
        />
    );
};
export default connector(LineChartWidget);
